module.exports = __webpack_public_path__ + "static/img/mjesecnaisplata.82129f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/mjesecnaisplata.png
// module id = ATeX
// module chunks = 0